import React from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from "@/components/ui/tooltip";

interface SidebarLogoProps {
  expanded: boolean;
  toggleSidebar?: () => void;
}

export const SidebarLogo = ({ expanded, toggleSidebar }: SidebarLogoProps) => {
  return (
    <div className={`flex items-center h-16 px-4 border-b border-og01-card ${expanded ? "justify-between" : "justify-center"}`}>
      {expanded && (
        <div className="flex items-center gap-2">
          <span className="font-heading text-xl og01-gradient-text font-semibold">OG01</span>
        </div>
      )}
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="h-10 w-10 rounded-lg hover:bg-og01-card transition-colors"
              onClick={toggleSidebar}
            >
              {expanded ? (
                <X className="h-5 w-5 text-og01-text-secondary hover:text-og01-text transition-colors" />
              ) : (
                <Menu className="h-5 w-5 text-og01-text-secondary hover:text-og01-text transition-colors" />
              )}
            </Button>
          </TooltipTrigger>
          <TooltipContent side="right" className="bg-og01-card border-og01-card text-og01-text">
            {expanded ? "Collapse menu" : "Expand menu"}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
